// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNav-TocSubLink-module--cls1--1KyVl","cls2":"SideNav-TocSubLink-module--cls2--kiclr SideNav-TocSubLink-module--cls1--1KyVl"};